import React from 'react';
import FusionFest2024  from 'views/FusionFest2024';
const LifeSkillPage = () => {
  return <FusionFest2024/>;
};

export default LifeSkillPage;
